import type { ActivePower } from './ActivePower';
import type { ReactivePower } from './ReactivePower';

export class Load {
  constructor(
    readonly p: ActivePower,
    readonly q: ReactivePower,
    readonly loadSource?: string
  ) {}
}
